import React, { useEffect } from "react";
import {
	Routes,
	Route,
	Outlet,
	useLocation,
	useNavigate,
} from "react-router-dom";
/// Css
import "./index.css";
import "./chart.css";
import "./step.css";

/// Layout
import Nav from "./layouts/nav";
import Footer from "./layouts/Footer";

/// Pages
import Error404 from "./common/Error404";

//Scroll To Top
import ScrollToTop from "./layouts/ScrollToTop";

import Admins from "./pages/Admin";
import AddAdmin from "./pages/Admin/AddAdmin";
import Profile from "./pages/Profile";
import ContactUs from "./pages/ContactUs";
import Products from "./pages/Products";
import AddProducts from "./pages/Products/AddProducts";
import Categories from "./pages/Categories";
import Static from "./pages/Setting/StaticPages/Static";
import Notification from "./pages/Notification";
import AddNotification from "./pages/Notification/AddNotification";
import Orders from "./pages/Orders";
import OrderDetails from "./pages/Orders/Details";
import Invoice from "./pages/Orders/Invoice";
import PromCodes from "./pages/PromoCodes";
import AddPromoCodes from "./pages/PromoCodes/AddPromoCodes";
import Banners from "./pages/Banners";
import Delivery from "./pages/Delivery";
import Home from "./pages/Dashboard";
import Users from "./pages/Users";
import UserProfile from "./pages/Users/Profile";
import MHNContactUs from "./pages/ContactUs";
import OrdersGuest from "./pages/OrdersGuest";
import OrderGuestDetails from "./pages/OrdersGuest/Details";
import InvoiceGuest from "./pages/OrdersGuest/Invoice";
import SubCategories from "./pages/SubCategories";
import PaymentLink from "./pages/PaymentLink";
import Permission from "./pages/CustomRules";
import AddPermission from "./pages/CustomRules/AddRole";
import Leadership from "./pages/Home/Leadership";
import AddLeadership from "./pages/Home/Leadership/AddLeadership";
import HomePage from "./pages/Home";
import SocialMedia from "./pages/Setting/SocialMedia";

const Markup = () => {
	const location = useLocation();
	const navigate = useNavigate();

	useEffect(() => {
		if (location?.pathname === "/login") {
			navigate("/");
		}
	}, [location]);

	const allroutes = [
		/// Dashboard
		{ url: "", component: <Home /> },
		{ url: "dashboard", component: <Home /> },

		// Admins
		{ url: "admins", component: <Admins /> },
		{ url: "admins/add-admins", component: <AddAdmin /> },
		{ url: "admins/edit-admin/:id/:name", component: <AddAdmin /> },

		// Users
		{ url: "users", component: <Users /> },
		{ url: "users/profile", component: <UserProfile /> },

		// Rules
		{ url: "roles", component: <Permission /> },
		{ url: "roles/add_role", component: <AddPermission /> },
		{ url: "roles/:id", component: <AddPermission /> },

		// Home
		{ url: "contact-us", component: <ContactUs /> },

		// Products
		{ url: "products", component: <Products /> },
		{ url: "products/add-products", component: <AddProducts /> },
		{ url: "products/add-products/:id", component: <AddProducts /> },

		{ url: "categories", component: <Categories /> },
		{ url: "sub-categories", component: <SubCategories /> },

		{ url: "contact-us", component: <MHNContactUs /> },

		// Home
		{ url: "leadership", component: <Leadership /> },
		{ url: "leadership/add-leadership", component: <AddLeadership /> },
		{ url: "home-page", component: <HomePage /> },

		//  => Notification
		{ url: "notification", component: <Notification /> },
		{ url: "notification/add-notification", component: <AddNotification /> },

		//  => Orders
		{ url: "orders", component: <Orders /> },
		// { url: "orders/add-orders", component: <AddOrders /> },
		{ url: "orders/details", component: <OrderDetails /> },
		{ url: "orders/invoice", component: <Invoice /> },

		//  => Orders Guest
		{ url: "orders-guest", component: <OrdersGuest /> },
		{ url: "orders-guest/details", component: <OrderGuestDetails /> },
		{ url: "orders-guest/invoice", component: <InvoiceGuest /> },

		//  => Promo Codes
		{ url: "promo-codes", component: <PromCodes /> },
		{ url: "promo-codes/add-promo-codes", component: <AddPromoCodes /> },
		{ url: "promo-codes/edit-promo-codes", component: <AddPromoCodes /> },

		//  => Banners
		{ url: "banners", component: <Banners /> },

		//  => Setting
		{ url: "social", component: <SocialMedia /> },
		{ url: "about-us", component: <Static /> },
		{ url: "privacy", component: <Static /> },
		{ url: "terms_and_conditions", component: <Static /> },
		{ url: "product/rules", component: <Static /> },
		{ url: "delivery", component: <Delivery /> },
		//Payment Link
		{ url: "payment-link", component: <PaymentLink /> },

		//Profile
		{ url: "profile", component: <Profile /> },

		// Error
		{ url: "*", component: <Error404 /> },
	];

	return (
		<>
			<Routes>
				<Route path="page-error-404" element={<Error404 />} />
				<Route element={<MainLayout />}>
					{allroutes.map((data, i) => (
						<Route
							key={i}
							exact
							path={`${data.url}`}
							element={data.component}
						/>
					))}
				</Route>
			</Routes>
			<ScrollToTop />
		</>
	);
};

function MainLayout() {
	return (
		<div id="main-wrapper" className={`show `}>
			<Nav />
			<div className="content-body" style={{ minHeight: "100vh" }}>
				<div className="container-fluid">
					<Outlet />
				</div>
			</div>
			<Footer />
		</div>
	);
}

export default Markup;
